module.exports = __webpack_public_path__ + "img/sticker-nye-darkfans-en.7d525f0b.svg";